import { Button, ButtonSize } from "./Button";
import { WHATSAPP_NUMBER } from "@/lib/v2/constants";

export function WhatsAppButton({
  text = "Hi Winnie, I would like to know more about aiproperty.sg.",
  label = "WhatsApp",
  size = "md",
}: {
  text?: string;
  label?: string;
  size?: ButtonSize;
}) {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
  return (
    <Button variant="whatsapp" size={size} href={href} target="_blank" rel="noopener noreferrer">
      {label}
    </Button>
  );
}
